import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMenuClass } from "../../../../../core/services/menu/menu.service";
import { IMonoOccurrence, IMonoOccurrenceOptions } from "../../../../../core/services/mono-occurrence.service";
import { IComponentController } from "angular";
import { IRoute } from "../../../../../core/interfaces/route.interface";
import { IMenuItemForageClass } from "../../../../../core/services/menu/menu-item-forage.service";
import { IMenuItemActionClass } from "../../../../../core/services/menu/menu-item-action.service";
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';

interface IPageGs0118 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence,
    medMultiOccurrenceOptions: IMultiOccurrenceOptions;
    medMultiOccurrence: IMultiOccurrence;
    hieMultiOccurrenceOptions: IMultiOccurrenceOptions;
    hprMultiOccurrenceOptions: IMultiOccurrenceOptions;
    hieMultiOccurrence: IMultiOccurrence;
}

/* @ngInject */
export default function Gs0118Controller(
    Menu: IMenuClass,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    MenuItemAction: IMenuItemActionClass,
    MenuItemForage: IMenuItemForageClass,
    gs0121Route: IRoute,
    gs0118Route: IRoute
) {
    const accueilRoute = { NAME: 'secure.accueil' };
    const vm: IPageGs0118 = this;

    vm.monoOccurrenceOptions = {
        actionsMore: new Menu([
            new MenuItemAction(
                'LBL_BTN_COPIER',
                'BOUCOP',
                () => ({}),
                {
                    icon: 'content_copy',
                    formulaireConfirmationAction: {
                        lblTitre: 'LBL_BTN_COPIER',
                        lblConfirm: 'G_LBL_BTN_COPIER',
                        largeurFormulaire: 30,
                        formulaire: new Formulaire([
                            new FormulaireItem('mencleintcop', { default: (data: any) => data.$id, hidden: true }),
                            new FormulaireItem('debut', { required: true })
                        ], { largeurDefaut: 100, }
                        )
                    }
                }
            )
        ]),
        formulaire: new Formulaire('LBL_BLC_MEN', [
            new FormulaireItem('mendsc'),
            new FormulaireItem('mendscmen'),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('vaesysapp', { required: true }),
            new FormulaireItem('vaesysmodsof', { required: true }),
            new FormulaireItem('menflgcen')
        ], { largeurDefaut: 33.33 })
    };

    // Bloc Hiérarchie Affichage hiérarchique
    vm.hieMultiOccurrenceOptions = {
        brisNiveaux: 'niveau',
        bloc: 'hie',
        fonctions: {
            nouveau: false,
            edition: false,
            supprime: false,
            recherche: false
        },
        colonnesVisibles: [
            {
                nom: 'meddscmen',
                largeur: 100
            }
        ],
        colonnesCachees: ['medcleintref', 'vaesysenttrt', 'newline', 'sec'],
        actionsRangeeDroite: new Menu([
            new MenuItemForage(
                '',
                (data: any) => getPageNom(data),
                (data: any) => getParametresGetter(data),
                { hidden: (data: any) => data.vaesysenttrt !== 'MEN' }
            )])
    };

    // Bloc Appartenance Affichage hiérarchique parents
    vm.hprMultiOccurrenceOptions = {
        brisNiveaux: 'niveau',
        bloc: 'hpr',
        fonctions: {
            nouveau: false,
            edition: false,
            supprime: false,
            recherche: false
        },
        actionsRangeeDroite: new Menu([
            new MenuItemForage(
                '',
                (data: any) => getPageNom(data),
                (data: any) => getParametresGetterParent(data),
                { hidden: (data: any) => 
                    (data.vaesysenttrt !== 'MEN')
                    || (data.medcleintref === data.mencleintparent)
                }
            )]),
        colonnesVisibles: [
            {
                nom: 'meddscmen',
                largeur: 100
            }
        ],
        colonnesCachees: ['medcleintref', 'vaesysenttrt', 'newline', 'sec', 'mencleintparent'],
    };

    vm.medMultiOccurrenceOptions = {
        actionsRangeeDroite: new Menu([
            new MenuItemForage(
                'LBL_FOR_TYP',
                (data: any) => getMedPageNom(data),
                (data: any) => getParametresGetter(data),
                { hidden: (data: any) => data.vaesysenttrt !== 'MEN' }
            )]),
        colonnesCachees: [
            'medcleintref',
            'vaesysenttrt'
        ],
        colonnesVisibles: [
            { nom: 'medcle', largeur: 100 },
            { nom: 'vaesysenttrt_dsc', largeur: 200 },
            { nom: 'meddsc', largeur: 300 },
            { nom: 'medcod', largeur: 150 }

        ],
        formulaire: new Formulaire([
            new FormulaireItem('medcle'),
            new FormulaireItem('vaesysenttrt'),
            new FormulaireItem('medcleintref', {
                largeur: 50,
                resourceParams: (data: any) => (
                    {
                        vaesysapp: vm.monoOccurrence.data.vaesysapp
                    })
            })
        ], { largeurDefaut: 25 })
    };
    
    function getMedPageNom(rowData: any): string {
        const vaesysenttrt = rowData?.vaesysenttrt
        if (vaesysenttrt === 'MEN') {
            return gs0118Route.NAME;
        } else {
            return accueilRoute.NAME;
        }
    }

    function getPageNom(rowData: any): string | undefined {
        const vaesysenttrt = rowData?.vaesysenttrt
        if (vaesysenttrt === 'MEN') {
            return gs0118Route.NAME
        }
        if (vaesysenttrt === 'MEC') {
            return gs0121Route.NAME
        }
        return undefined
    }

    function getParametresGetterParent(rowData: any): object | undefined {
        const vaesysenttrt = rowData?.vaesysenttrt
        const medcleintref = rowData?.mencleintparent
        return getParam(vaesysenttrt, medcleintref)
    }

    function getParametresGetter(rowData: any): object | undefined {
        const vaesysenttrt = rowData?.vaesysenttrt
        const medcleintref = rowData?.medcleintref
        return getParam(vaesysenttrt, medcleintref)
    }

    function getParam(vaesysenttrt: string, cle: number): object | undefined {
        if (vaesysenttrt === 'MEN' || vaesysenttrt === 'MEC') {
            return {
                id: cle,
                mencle: cle
            }
        }
        return undefined
    }

}
